import alchemy from "@/store/character/alchemy";
import attributes from "@/store/character/attributes";
import build from "@/store/character/build";
import details from "@/store/character/details";
import exceptional from "@/store/character/exceptional";
import inventory from "@/store/character/inventory";
import status from "@/store/character/status";
import skills from "@/store/character/skills";
import spells from "@/store/character/spells";
import martialPerks from "@/store/character/martialPerks";
import martialAttacks from "@/store/character/martialAttack";

export default {
  namespaced: true,
  modules: {
    alchemy,
    attributes,
    build,
    details,
    exceptional,
    inventory,
    status,
    skills,
    spells,
    martialPerks,
    martialAttacks,
  },
  state: {},
  getters: {},
  mutations: {},
};
